export default "__VITE_ASSET__DHgIKgOp__"